<template>
    <select :value="modelValue" class="appearance-none" @change="$emit('update:modelValue', $event.target.value)" ref="input">
        <option value="" disabled>{{ placeholder }}</option>
        <option v-for="(text, value) in options" :key="value" :value="value">{{ text }}</option>
    </select>
</template>

<script>
export default {
    props: {
        modelValue: String,
        placeholder: String,
        options: {
            type: Object,
            default:[]
        }
    },

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
}
</script>
